module.exports = __webpack_public_path__ + "img/building.58184f92.jpg";